import { useTranslation } from "react-i18next";
import { ROUTES_CONSTANTS } from "../constants";

const ErrorFallback = ({ error, resetError }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h1 className="mb-2 text-xl font-semibold text-gray-900">
          {t("error.title")}
        </h1>
        <p className="mb-6 text-sm text-gray-500">
          {t("error.subtitle")}
        </p>
        {import.meta.env.DEV && error && (
          <pre className="mb-6 max-h-32 overflow-auto rounded bg-gray-100 p-3 text-left text-xs text-red-700">
            {error.message}
          </pre>
        )}
        <button
          onClick={() => {
            resetError();
            window.location.replace(ROUTES_CONSTANTS.NO_ROUTE);
          }}
          className="rounded-md bg-primary-500 px-6 py-2 text-sm font-medium text-white transition hover:bg-primary-600"
        >
          {t("error.btnGoHome")}
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
